import { CommonModule } from '@angular/common';
import { Component, TemplateRef, inject } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { NgbDropdownModule, NgbCollapseModule, NgbOffcanvas, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from '../../Util/Session/session.service';
import { ShareTypeService } from '../../Model/OneFeildMasters/share-type.service';
import { CommonService } from '../../Model/Common/common.service';
import { NotificationService } from '../../Model/Notification/notification.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { UtilityService } from '../../Model/utility/utility.service';
import moment from 'moment';
import { UserRightService } from '../../Model/UserRight/user-right.service';
import { debug } from 'console';
import { ApprovalMatrixService } from '../../Model/ApprovalMatrix/approval-matrix.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { CompanySelectionComponent } from '../CompanySelection/company-selection/company-selection.component';
import { EmpDetailComponent } from '../../Component/emp-detail/emp-detail.component';
import { MPINDialogComponent } from '../../Component/mpindialog/mpindialog.component';
import { LoginService } from '../../Model/Login/login.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { Tooltip } from 'chart.js';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { PasswordComponent } from '../../Component/password/password.component';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DashboardService } from '../../Model/Dashboard/dashboard.service';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-main-layout3',
  standalone: true,
  imports: [CommonModule, NgbDropdownModule, NgbCollapseModule, RouterOutlet, RouterModule, FormsModule],
  templateUrl: './main-layout3.component.html',
  styleUrl: './main-layout3.component.scss'
})
export class MainLayout3Component {
  private searchTerms = new Subject<string>();
  private destroy$ = new Subject<void>(); // For unsubscribing

  user: any;
  menus = [] as any;
  originalmenus = [] as any;
  searchtext = '';
  isDisabled: boolean = false
  // Collapsed = {
  //   Dasboard: { isCollapsed: true, },
  //   Master: {
  //     isCollapsed: true,
  //     Holiday: { isCollapsed: true, },
  //     MISMaster: { isCollapsed: true, },
  //     Site: { isCollapsed: true }
  //   },
  //   Setting: { isCollapsed: true, },
  //   Request: { isCollapsed: true, },
  //   Todo: { isCollapsed: true, },
  //   AssetModule: { isCollapsed: true, }
  // };
  private offcanvasService = inject(NgbOffcanvas);

  filter = {
    showNotification: 2,
    FromDate: '' as any,
    ToDate: '' as any,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
  }

  ExpandedMenu = true;
  isCollapsed = true;
  isSubCollapsed = false;
  Notifications = [] as any;
  NotificationsMain = [] as any;
  ApprovalSubMenus = [] as any;
  PendingCounts = [] as any;
  intervalID = null as any;
  acivepath = null;

  NotificationIds: any;
  ReadUnreadAll: boolean = false;
  //TotalPendingCount : number = 0
  constructor(
    private dashboard: DashboardService,
    private session: SessionService,
    protected common: CommonService,
    private notification: NotificationService,
    private toast: ToastService,
    private router: Router,
    private modalService: NgbModal,
    private utility: UtilityService,
    private userright: UserRightService,
    private approvalMatrix: ApprovalMatrixService,
    private dateFormat: CustomDateParserFormatter,
    private login: LoginService,
    private tooltip: TooltipService
  ) {
    if (this.common.IsMobile()) {
      this.ExpandedMenu = false;
    }

    this.user = this.session.GetUserDetails();
    try {
      if (this.user.ApiUrl == null || this.user.ApiUrl == '' || this.user.ApiUrl == undefined) {
        this.user.ApiUrl = environment.API_URL_Main;
      }
    } catch (e) {
      this.user.ApiUrl = environment.API_URL_Main;
    }
    this.user.Date = new Date().getDate() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getFullYear();
    //setInterval(this.NotificationGetUnread, 100000, 'S');
  }

  ngOnInit() {
    this.searchTerms.pipe(
      debounceTime(300), // Wait for 300ms after the last key press
      distinctUntilChanged(), // Only emit if the value has changed
      //takeUntil(this.destroy$) // Unsubscribe on component destruction
    ).subscribe(term => {
      this.SearchMenu(); // Call your function here
    });

    if (this.user.UserType == 'E') {
      this.filter.EmpMappingId = this.user.UserId;
    }
    this.NotificationGetUnread('S');
    this.ESS_ProfileMenuRightsView();
    this.SelectDate('RegistrationDate', null, null);
  }

  Logout() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to logout?';
    modalRef.result.then(result => {
      if (result) {
        this.utility.LogOutDetails({ 'SelectType': 'LogOut', LoginName: this.user.LoginName }).subscribe({
          next: (response) => {
            if (response.Error_Code == "09")
              this.session.End();
          },
          complete: () => { },
          error: (error) => { },
        });
      }
    });

    // if (false) {
    //   const data = {
    //     EmpCode: this.user.EmpCode,
    //     UserType: this.user.UserType,
    //     EPhoto: this.common.PhotoLink(this.user.EPhoto),
    //     UserName: this.user.UserName,
    //   };
    //   const jsonData = JSON.stringify(data);
    //   this.setCookie('MaxEdgeUserdata', jsonData, 30);
    // }
    clearInterval(this.intervalID);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    clearInterval(this.intervalID);
  }

  navigateTo(route: string, label: string): void {
    //this.sharetype.TypeData(label);
    sessionStorage.setItem('TypeOfSingleFieldMaster', label);
    sessionStorage.setItem('Div', route);
    // this.sharetype.TypeData1(route);
  }

  // IsView(Page: String) {
  //   if (this.user.UserType == 'A' && (Page == 'Dashboard' || Page == 'Master' || Page == 'MasterHoliday' || Page == 'MasterRole' || Page == 'MasterTAT' || Page == 'MasterSiteGeoMapping' || Page == 'MasterBranchGeoMapping' || Page == 'MasterMultipleLocationGeoMapping' || Page == 'MasterShift'
  //     || Page == 'Setting' || Page == 'SettingApprovalMatrix' || Page == 'SettingAttendancePolicies' || Page == 'SettingRegularizationPolicies' || Page == 'SettingWeekoffPolicies' || Page == 'SettingShiftPolicies' || Page == 'SettingLeavePolicies'
  //     // || Page == 'Request' || Page == 'RequestLeave' || Page == 'RequestAttendance' || Page == 'RequestRegularization' 
  //     || Page == 'Approval' || Page == 'ApprovalLeave' || Page == 'ApprovalRegularization' || Page == 'ApprovalAttendance' || Page == 'Leave' || Page == 'Feed'
  //     || Page == 'OnBoarding'
  //   )) {
  //     return true;
  //   } else if (this.user.UserType == 'E' && (Page == 'Myself'
  //     || Page == 'Request' || Page == 'RequestLeave' || Page == 'RequestAttendance' || Page == 'RequestRegularization' || Page == 'HolidayList')) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  NotificationGetUnread(SelectType: String) {
    this.notification.NotificationGetUnread({ SelectType: SelectType, UserType: this.user.UserType, CreatedFor: this.user.UserId }).subscribe({
      next: (response) => {
        if (SelectType == 'S') {
          this.common.NotificationCount = response.Table[0].NotificationCount;
        }
        // else if (SelectType == 'D') {
        //   this.Notifications = response.Table;
        // }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  Notification_GetAllSelect(SelectType: String) {
    this.notification.Notification_GetAllSelect({ SelectType: SelectType, UserType: this.user.UserType, CreatedFor: this.user.UserId }).subscribe({
      next: (response) => {
        if (SelectType == 'All') {
          this.NotificationsMain = response.Table
          this.common.NotificationCount = response.Table.filter((e: any) => !e.IsRead).length;
        }
      },
      complete: () => {
        this.filterNotification();
      },
      error: (error) => { },
    });
  }

  ESS_NotificationInsertUpdate(id: any, isAction = false) {
    this.notification.ESS_NotificationInsertUpdate({ SelectType: 'U', WEBESSNotificationId: id, UserType: this.user.UserType, EmpMasterId: this.user.UserId, IsRead: true }).subscribe({
      next: (response) => {
        if (response.Error_Code == '255') {
          if (id == 'All') {
            this.common.NotificationCount = 0;
            this.Notifications.map((e: any) => e.IsRead = true);
            this.Notifications = [];
          } else {
            if (!this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['IsRead']) {
              this.common.NotificationCount -= 1;
              this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['IsRead'] = true;
              this.Notifications.splice(this.Notifications.findIndex((e: any) => e.WEBESSNotificationId == id), 1);
            }
          }
          if (!isAction) {
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
          } else {
            if (this.user.UserType == 'A') {
              if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 5) {
                this.router.navigate(['todo/leaveapproval/detail/', this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']]);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 4) {
                this.router.navigate(['todo/regularizationapproval/detail/', this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']]);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 3) {
                this.router.navigateByUrl('todo/attendanceapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 16) {
                this.router.navigateByUrl('todo/reimbursementapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 16) {
                this.router.navigateByUrl('todo/reimbursementapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 1) {
                this.router.navigateByUrl('todo/registrationapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 2) {
                this.router.navigateByUrl('todo/registrationapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 6) {
                this.router.navigateByUrl('todo/opholidayapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 13) {
                this.router.navigateByUrl('todo/compensatoryoffapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 14) {
                this.router.navigateByUrl('todo/compensatoryoffconsumeapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 15) {
                this.router.navigateByUrl('todo/advanceapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 8) {
                this.router.navigateByUrl('todo/expenseapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 17) {
                this.router.navigateByUrl('todo/employeeconfirmation/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 18) {
                this.router.navigateByUrl('todo/letterapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
                this.offcanvasService.dismiss('Cross click')
              }
              else {
                //this.toast.show({ message: 'Module not found', type: toastTypeEnum.warning });
              }
            } else if (this.user.UserType == 'E') {
              if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 5) {
                this.router.navigate(['request/leave/']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 4) {
                this.router.navigate(['request/regularization/']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 3) {
                this.router.navigate(['request/attendance/']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 16) {
                this.router.navigate(['request/reimbursement/']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 13) {
                this.router.navigate(['request/compensatoryoff/']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 14) {
                this.router.navigate(['request/compensatoryoffconsume/']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 15) {
                this.router.navigate(['request/advanceexpense/']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 8) {
                this.router.navigate(['request/expense/']);
                this.offcanvasService.dismiss('Cross click')
              } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 18) {
                this.router.navigate(['letter/empletter/']);
                this.offcanvasService.dismiss('Cross click')
              } else {
                //this.toast.show({ message: 'Module not found', type: toastTypeEnum.warning });
              }
            } else {
              this.toast.show({ message: 'Unauthorized access', type: toastTypeEnum.warning });
            }
          }
        } else {
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  filterNotification() {
    if (this.filter.showNotification == 0) {//all
      this.Notifications = this.NotificationsMain;
    } else if (this.filter.showNotification == 1) {//read
      this.Notifications = this.NotificationsMain.filter((e: any) => e.IsRead);
    } else if (this.filter.showNotification == 2) {//unread
      this.Notifications = this.NotificationsMain.filter((e: any) => !e.IsRead);
    }
    this.ReadUnreadAll = false
  }

  openNotification(content: TemplateRef<any>) {
    this.Notification_GetAllSelect('All');
    this.offcanvasService.open(content, { position: 'end' });
  }

  ESS_ProfileMenuRightsView() {
    this.userright.ESS_ProfileMenuRightsView({ SelectType: 'View', Module: this.user.Module }).subscribe({
      next: (response) => {
        try {
          this.menus = response;
          this.originalmenus = response;
          if (this.menus.find((menu: any) => menu.MenuLabel == 'Approval') != undefined) {
            this.ApprovalSubMenus = this.menus.find((menu: { MenuLabel: string; }) => menu.MenuLabel == 'Approval').SubMenus;
          }

          // console.log(this.ApprovalSubMenus.forEach((obj: { MenuLabel: any }) => console.log(obj.MenuLabel)));

          this.menus.forEach((element: any) => {
            if (element.SubMenus.length > 0) {
              element.SubMenus.forEach((element2: any) => {
                if (element2.SubMenus.length > 0) {
                  element2.SubMenus.forEach((element3: any) => {
                    if (element3.SubMenus.length > 0) {
                      element3.SubMenus.forEach((element4: any) => {
                        if (element4.SubMenus.length > 0) {
                          this.common.selectedmenuID = element4.ESS_MenuMasterId;
                        }
                      });
                    } else {
                      if (element3.URL == this.router.url) {
                        this.common.selectedmenuID = element2.ESS_MenuMasterId;
                      }
                    }
                  });
                } else {
                  if (element2.URL == this.router.url) {
                    this.common.selectedmenuID = element2.ESS_MenuMasterId;
                  }
                }
              });
            } else {
              if (element.URL == this.router.url) {
                this.common.selectedmenuID = element.ESS_MenuMasterId;
              }
            }
          });
        } catch (e) { this.menus = [] }

        //this.router.url
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  setIsCollapsed(menu: any) {
    menu.isCollapsed = true;
  }

  ESS_GetPendingApprovalSummary() {
    this.filter.FromDate = this.filter.FromDateObj.year + '-' + this.filter.FromDateObj.month + '-' + this.filter.FromDateObj.day;
    this.filter.ToDate = this.filter.ToDateObj.year + '-' + this.filter.ToDateObj.month + '-' + this.filter.ToDateObj.day;
    this.approvalMatrix.ESS_GetPendingApprovalSummary({ SelectType: 'S', EmpMappingId: this.filter.EmpMappingId }).subscribe({
      next: (response) => {
        if (response.Table) {

          this.PendingCounts = response.Table;
          this.common.MenuCounts.Approval.Leave = response.Table.filter((e: any) => e.WebESSModuleMasterId == 5).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 5)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.Regularization = response.Table.filter((e: any) => e.WebESSModuleMasterId == 4).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 4)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.Attendance = response.Table.filter((e: any) => e.WebESSModuleMasterId == 3).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 3)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.Registration.MenualOnBoard = response.Table.filter((e: any) => e.WebESSModuleMasterId == 1).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 1)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.Registration.PreOnBoard = response.Table.filter((e: any) => e.WebESSModuleMasterId == 2).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 2)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.OptionalHoliday = response.Table.filter((e: any) => e.WebESSModuleMasterId == 6).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 6)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.CompensatoryOff = response.Table.filter((e: any) => e.WebESSModuleMasterId == 13).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 13)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.CompensatoryOffConsume = response.Table.filter((e: any) => e.WebESSModuleMasterId == 14).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 14)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.Reimbursement = response.Table.filter((e: any) => e.WebESSModuleMasterId == 16).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 16)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.ExpenseAdvance = response.Table.filter((e: any) => e.WebESSModuleMasterId == 15).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 15)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.Expense = response.Table.filter((e: any) => e.WebESSModuleMasterId == 8).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 8)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.EmpConfirmation = response.Table.filter((e: any) => e.WebESSModuleMasterId == 17).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 17)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.Letter = response.Table.filter((e: any) => e.WebESSModuleMasterId == 18).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 18)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.Profile = response.Table.filter((e: any) => e.WebESSModuleMasterId == 7).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 7)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.Outdoor = response.Table.filter((e: any) => e.WebESSModuleMasterId == 20).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 20)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.TaxDeclaration = response.Table.filter((e: any) => e.WebESSModuleMasterId == 9).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 9)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.TaxInvestment = response.Table.filter((e: any) => e.WebESSModuleMasterId == 10).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 10)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.DeviceImage = response.Table.filter((e: any) => e.WebESSModuleMasterId == 21).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 21)[0].PendingCount : 0;
          this.common.MenuCounts.Approval.ProfileImage = response.Table.filter((e: any) => e.WebESSModuleMasterId == 22).length > 0 ? response.Table.filter((e: any) => e.WebESSModuleMasterId == 22)[0].PendingCount : 0;

          // this.common.TotalPendingCount = response.Table.reduce((sum: any, row: { PendingCount: any; }) => {
          //   return sum + (row.PendingCount || 0);
          // }, 0);
          this.common.TotalPendingCount = this.TotalPending();
        }
        // if (ModuleMasterId == 5) {
        //   this.common.MenuCounts.Approval.Leave = response.Table[0].PendingCount;
        // } else if (ModuleMasterId == 4) {
        //   this.common.MenuCounts.Approval.Regularization = response.Table[0].PendingCount;
        // } else if (ModuleMasterId == 3) {
        //   this.common.MenuCounts.Approval.Attendance = response.Table[0].PendingCount;
        // } else if (ModuleMasterId == 1) {
        //   this.common.MenuCounts.Approval.Registration.MenualOnBoard = response.Table[0].PendingCount;
        // } else if (ModuleMasterId == 2) {
        //   this.common.MenuCounts.Approval.Registration.PreOnBoard = response.Table[0].PendingCount;
        // } else if (ModuleMasterId == 6) {
        //   this.common.MenuCounts.Approval.OptionalHoliday = response.Table[0].PendingCount;
        // } else if (ModuleMasterId == 13) {
        //   this.common.MenuCounts.Approval.CompensatoryOff = response.Table[0].PendingCount;
        // } else if (ModuleMasterId == 14) {
        //   this.common.MenuCounts.Approval.CompensatoryOffConsume = response.Table[0].PendingCount;
        // } else if (ModuleMasterId == 16) {
        //   this.common.MenuCounts.Approval.Reimbursement = response.Table[0].PendingCount;
        // } else if (ModuleMasterId == 15) {
        //   this.common.MenuCounts.Approval.ExpenseAdvance = response.Table[0].PendingCount;
        // } else if (ModuleMasterId == 8) {
        //   this.common.MenuCounts.Approval.Expense = response.Table[0].PendingCount;
        // } else if (ModuleMasterId == 17) {
        //   this.common.MenuCounts.Approval.EmpConfirmation = response.Table[0].PendingCount;
        // }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.filter.FromDateObj.day = 1;
          this.filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.filter.ToDateObj.day = new Date(this.filter.ToDateObj.year, this.filter.ToDateObj.month, 0).getDate();
        }
        // this.ApprovalMatrixRequestGetCount(1);
        // this.ApprovalMatrixRequestGetCount(2);
        // this.ApprovalMatrixRequestGetCount(3);
        // this.ApprovalMatrixRequestGetCount(4);
        // this.ApprovalMatrixRequestGetCount(5);
        // this.ApprovalMatrixRequestGetCount(6);
        // this.ApprovalMatrixRequestGetCount(13);
        // this.ApprovalMatrixRequestGetCount(14);
        // this.ApprovalMatrixRequestGetCount(16);
        // this.ApprovalMatrixRequestGetCount(15);
        // this.ApprovalMatrixRequestGetCount(8);
        // this.ApprovalMatrixRequestGetCount(17);
        this.ESS_GetPendingApprovalSummary();
      },
      complete: () => { },
      error: (error) => {
        return false;
      },
    });
  }

  CompanySelection() {
    const modalRef = this.modalService.open(CompanySelectionComponent);
    modalRef.result.then(
      (result: any) => {
        if (result) {
          window.location.reload();
        }
      },
      () => { }
    );
  };

  search() {
    const modalRef = this.modalService.open(EmpDetailComponent, { centered: true, backdrop: 'static', size: 'xl' });
  }

  setCookie(name: string, value: string, days: number) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
  }

  ESS_GetLoginDetails(isAuto: Boolean) {
    this.login.ESS_GetLoginDetails({ SelectType: 'AuthInfo', LoginName: this.user.EmpCode, TokenUserName: this.user.TokenUserName, TokenPassword: this.user.TokenPassword, TokenAppName: this.user.TokenAppName, Token: this.user.Token, SessionID: this.user.SessionID, OpType: this.user.OpType, UserType: this.user.UserType }, this.user.ApiUrl).subscribe({
      next: (response) => {
        if (response && response.Table.length > 0) {
          if (response.Table[0].IsMPINEnabled && ((isAuto && response.Table[0].IsMPINSet == 0) || !isAuto)) {
            this.modalService.open(MPINDialogComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
          }
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  ChangePassword() {
    this.modalService.open(PasswordComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
  }

  moduleList() {
    if (this.user.UserType == 'A' && this.common.CompanyParameterValue.AllModulesRights) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae3;
      return modalRef.result.then((result) => {
        if (result) {
          this.router.navigate(['module'], { replaceUrl: true });
        }
      });
    } else {
      return false;
    }
  }


  selectAll(event: any) {
    const isChecked = event.target.checked;
    this.Notifications.forEach((shift: { selected: any; }) => {
      shift.selected = isChecked;
    });
  }

  selectRow(event: any, shift: any) {
    shift.selected = event.target.checked;
  }

  ESS_NotificationInsertUpdat(SelectType: string = '') {
    SelectType = this.filter.showNotification == 1 ? 'Unread' : 'U'
    const selectedItems = this.Notifications.filter((item: { selected: any; }) => item.selected);
    if (selectedItems.length === 0) {
      this.toast.show({ message: 'Please select at least 1 Notification!', type: toastTypeEnum.warning });
      return;
    }
    const NotifyIDs = selectedItems.map((item: { [x: string]: any; }) => item['WEBESSNotificationId']);
    this.NotificationIds = NotifyIDs.join(', ');
    this.notification.ESS_NotificationInsertUpdate({ SelectType: SelectType, WEBESSNotificationId: this.NotificationIds, UserType: this.user.UserType, EmpMasterId: this.user.UserId, IsRead: true }).subscribe({
      next: (response) => {
        if (response.Error_Code == '255' || response.Error_Code == '639') {
          // if (id == 'All') {
          //   this.common.NotificationCount = 0;
          //   this.Notifications.map((e: any) => e.IsRead = true);
          //   this.Notifications = [];
          // } else {
          //   if (!this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['IsRead']) {
          //     this.common.NotificationCount -= 1;
          //     this.Notifications.filter((e: any) => e.WEBESSNotificationId == id)[0]['IsRead'] = true;
          //     this.Notifications.splice(this.Notifications.findIndex((e: any) => e.WEBESSNotificationId == id), 1);
          //   }
          // }
          //this.Notification_GetAllSelect('All');
          this.Notification_GetAllSelect('All');
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });

          //  else {
          //   if (this.user.UserType == 'A') {
          //     if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 5) {
          //       this.router.navigate(['todo/leaveapproval/detail/', this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']]);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 4) {
          //       this.router.navigate(['todo/regularizationapproval/detail/', this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']]);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 3) {
          //       this.router.navigateByUrl('todo/attendanceapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 16) {
          //       this.router.navigateByUrl('todo/reimbursementapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 16) {
          //       this.router.navigateByUrl('todo/reimbursementapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 1) {
          //       this.router.navigateByUrl('todo/registrationapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 2) {
          //       this.router.navigateByUrl('todo/registrationapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 6) {
          //       this.router.navigateByUrl('todo/opholidayapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 13) {
          //       this.router.navigateByUrl('todo/compensatoryoffapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 14) {
          //       this.router.navigateByUrl('todo/compensatoryoffconsumeapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 15) {
          //       this.router.navigateByUrl('todo/advanceapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 8) {
          //       this.router.navigateByUrl('todo/expenseapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 17) {
          //       this.router.navigateByUrl('todo/employeeconfirmation/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 18) {
          //       this.router.navigateByUrl('todo/letterapproval/detail/' + this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WebESSApprovalRequestTrackingId']);
          //       this.offcanvasService.dismiss('Cross click')
          //     }
          //     else {
          //       //this.toast.show({ message: 'Module not found', type: toastTypeEnum.warning });
          //     }
          //   } else if (this.user.UserType == 'E') {
          //     if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 5) {
          //       this.router.navigate(['request/leave/']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 4) {
          //       this.router.navigate(['request/regularization/']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 3) {
          //       this.router.navigate(['request/attendance/']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 16) {
          //       this.router.navigate(['request/reimbursement/']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 13) {
          //       this.router.navigate(['request/compensatoryoff/']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 14) {
          //       this.router.navigate(['request/compensatoryoffconsume/']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 15) {
          //       this.router.navigate(['request/advanceexpense/']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 8) {
          //       this.router.navigate(['request/expense/']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else if (this.NotificationsMain.filter((e: any) => e.WEBESSNotificationId == id)[0]['WEBESSModuleMasterId'] == 18) {
          //       this.router.navigate(['letter/empletter/']);
          //       this.offcanvasService.dismiss('Cross click')
          //     } else {
          //       //this.toast.show({ message: 'Module not found', type: toastTypeEnum.warning });
          //     }
          //   }
          //    else {
          //     this.toast.show({ message: 'Unauthorized access', type: toastTypeEnum.warning });
          //   }
          // }
        } else {
          this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  autoExpandedMenu() {
    if (this.common.IsMobile()) {
      this.ExpandedMenu = false;
    }
  }

  get displayCompanyName(): string {
    return this.common.IsMobile() ? this.user.CompanyCode : this.user.CompanyName;
  }

  ContainsObject(value: any) {
    return this.ApprovalSubMenus.some((obj: { MenuLabel: string; }) => obj['MenuLabel'] == value);
  }

  TotalPending() {
    let totalPending = 0;
    if (this.user.UserType.toLowerCase() == 'a') {
      this.ApprovalSubMenus.forEach((submenu: any) => {
        if (submenu.ESS_MenuMasterId == 33) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 5);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 34) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 4);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 35) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 3);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 47) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 1);
          totalPending += match ? match.PendingCount : 0;

          const match2 = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 2);
          totalPending += match2 ? match2.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 93) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 6);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 106) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 13);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 107) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 14);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 116) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 16);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 120) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 15);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 121) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 8);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 133) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 17);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 154) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 18);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 169) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 7);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 271) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 20);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 286) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 9);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 287) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 10);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 295) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 21);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 296) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 22);
          totalPending += match ? match.PendingCount : 0;
        }
      });
    }
    else if (this.user.UserType.toLowerCase() == 'e') {
      this.ApprovalSubMenus.forEach((submenu: any) => {
        if (submenu.ESS_MenuMasterId == 98) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 5);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 99) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 4);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 100) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 3);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 101) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 6);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 104) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 13);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 105) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 14);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 115) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 16);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 140) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 15);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 141) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 8);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 142) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 17);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 161) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 18);
          totalPending += match ? match.PendingCount : 0;
        }
        else if (submenu.ESS_MenuMasterId == 273) {
          const match = this.PendingCounts.find((e: any) => e.WebESSModuleMasterId == 20);
          totalPending += match ? match.PendingCount : 0;
        }
      });
    }


    return totalPending;
  }

  DataTableRerender() {
    setTimeout(() => {
      const dataTable = $('.customeDatatable').DataTable();
      if (dataTable) {
        dataTable.columns.adjust();
        // Force multiple adjustments
        setTimeout(() => dataTable.columns.adjust(), 50);
        setTimeout(() => dataTable.columns.adjust(), 200);
      }
    }, 400);
  }

  SearchonKey(event: any) {
    this.searchTerms.next(event.target.value);
  }

  SearchMenu() {
    this.menus = []
    if (this.searchtext == null || this.searchtext == '') {
      this.menus = this.originalmenus.map((e: any) => e);
    } else {
      if (this.searchtext.length > 0) {
        this.originalmenus.forEach((e: any) => {
          this.Second(e);
        })
      }
    }
  }

  Second(menu: any) {
    if (menu.MenuLabel.toLowerCase().includes(this.searchtext.toLowerCase())) {
      if (menu.SubMenus.length == 0) {
        if (this.menus.filter((e: any) => e.ESS_MenuMasterId == menu.ESS_MenuMasterId).length == 0) {
          this.menus.push({ ...menu, SubMenus: [] });
        }
      }
    }

    if (menu.SubMenus.length > 0) {
      menu.SubMenus.forEach((e: any) => {
        this.Second(e);
      })
    }
  }
}